export default __webpack_public_path__ + "static/media/Pilgrim's Harness of the Crumbling Tower.00870f98.jpg";